import {ACTION_CONFIG, ActionState} from "@/configs/ActionConfig";
import {TOGGLE_GETTING_STARTED} from "../constants/Action";

const initAction = {
    ...ACTION_CONFIG
};

// Define the action interface
interface ToggleCollapsedGettingStartedAction {
    type: typeof TOGGLE_GETTING_STARTED;
    gettingStartedCollapsed: boolean;
}

type Action = ToggleCollapsedGettingStartedAction;

export const ActionReducer = (state = initAction, action: Action) : ActionState => {
    switch (action.type) {
        case TOGGLE_GETTING_STARTED:
            return {
                ...state,
                gettingStartedCollapsed: action.gettingStartedCollapsed
            };
            
        default:
            return state;
    }
};
